import React from 'react'
import classNames from 'classnames'

const CLASS_NAME = 'heimr-hamburger-button'

export default ({ items, onOpen, onClose, open }) => {
  const classes = classNames(CLASS_NAME, open ? `${CLASS_NAME}--open` : '')

  return (
    <button
      open={open}
      onClick={() => {
        open ? onClose() : onOpen()
      }}
      className={classes}
    >
      {open ? '×' : '☰'}
    </button>
  )
}
